import * as React from "react";
import LinearProgress, { LinearProgressProps } from "@mui/material/LinearProgress";

export interface OrangeLinearProgressProps extends LinearProgressProps {
  position?: "absolute" | "relative" | "fixed" | "sticky";
}

/**
 * Global LinearProgress component with orange color (#F4A259)
 * Can be used as LoadingOverlay in DataGrid or standalone
 */
const OrangeLinearProgress: React.FC<OrangeLinearProgressProps> = ({
  position = "absolute",
  sx,
  ...props
}) => {
  return (
    <LinearProgress
      {...props}
      sx={{
        position,
        top: position === "absolute" ? 0 : undefined,
        left: position === "absolute" ? 0 : undefined,
        right: position === "absolute" ? 0 : undefined,
        zIndex: 4,
        "& .MuiLinearProgress-bar": {
          backgroundColor: "#F4A259",
        },
        "& .MuiLinearProgress-bar1Indeterminate": {
          backgroundColor: "#F4A259",
        },
        "& .MuiLinearProgress-bar2Indeterminate": {
          backgroundColor: "#F4A259",
        },
        ...sx,
      }}
    />
  );
};

export default OrangeLinearProgress;

